<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { EbomPartSnoozeStatus } from '@/generated/graphql'
import { ref, watch } from 'vue'

const model = defineModel<EbomPartSnoozeStatus[]>({ default: [EbomPartSnoozeStatus.None] })
const { t } = useI18n()

const activateNotSnoozed = ref(true)
const activatePathArticle = ref(false)
const activateRevision = ref(false)
const activateQuantity = ref(false)
watch(model, (v) => {
  if (v.includes(EbomPartSnoozeStatus.None)) {
    activateNotSnoozed.value = true
  }
  if (v.includes(EbomPartSnoozeStatus.PathArticle)) {
    activatePathArticle.value = true
  }
  if (v.includes(EbomPartSnoozeStatus.PathArticleRevision)) {
    activateRevision.value = true
  }
  if (v.includes(EbomPartSnoozeStatus.PathArticleRevisionQuantity)) {
    activateQuantity.value = true
  }
})
</script>

<template>
  <v-menu :close-on-content-click="false">
    <template #activator="scope">
      <slot v-bind="scope" name="activator" />
    </template>
    <v-list v-model:selected="model" select-strategy="leaf">
      <v-list-subheader>
        {{ t('component.ebomPartSnoozeFilters.explanation') }}
      </v-list-subheader>
      <v-list-item
        v-for="s in EbomPartSnoozeStatus"
        :key="s"
        :value="s"
        :title="t(`entity.ebomPartSnooze.status.${s}`)"
      >
        <template #prepend="{ isSelected, select }">
          <v-list-item-action start>
            <v-checkbox-btn :model-value="isSelected" @update:model-value="select"></v-checkbox-btn>
          </v-list-item-action>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped lang="scss"></style>
